// extracted by mini-css-extract-plugin
module.exports = {"full-screen":"AppLayout_full-screen__1gSMy"};